import { useTranslation } from 'react-i18next';

/**
 * Der Name eines Moduls -- der Schluessel selbst, wenn es keinen Text gibt.
 *
 * **Eigene Datei und nicht neben der Komponente.** Ein Modul, das eine
 * Komponente **und** etwas anderes ausfuehrt, verliert das schnelle Neuladen
 * im Entwicklungsserver (`react-refresh`): Jede Aenderung laedt dann die
 * ganze Seite neu statt nur den Baustein. Bei einer Datei, die von zwei
 * Seiten und einer Kachel benutzt wird, faellt das sofort auf.
 *
 * **Der Rueckfall ist der Schluessel selbst.** Ein neues Modul im Server
 * erscheint damit sofort in der Auswahl -- unter seinem englischen Namen,
 * bis jemand die Sprachdatei nachzieht. Eine leere Zelle waere unauffaellig
 * und schlimmer.
 */
export function useModuleLabel(): (key: string) => string {
  const { t } = useTranslation();
  return (key: string) => t(`auditModule.${key}`, { defaultValue: key });
}
